import { createSlice } from '@reduxjs/toolkit';
import { findAddOnCategory } from './api';
import { initialState } from './api/interface';

const addOnCategorySlice = createSlice({
  name: 'addOnCategory',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findAddOnCategory.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findAddOnCategory.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findAddOnCategory.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } = addOnCategorySlice.actions;
export default addOnCategorySlice.reducer;
